import { render, staticRenderFns } from "./dcFundList.vue?vue&type=template&id=a7baff04&scoped=true"
import script from "./dcFundList.vue?vue&type=script&lang=js"
export * from "./dcFundList.vue?vue&type=script&lang=js"
import style0 from "./dcFundList.vue?vue&type=style&index=0&id=a7baff04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7baff04",
  null
  
)

export default component.exports